var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceMouthopenOutline = function SvgFaceMouthopenOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 12c0 4.894 3.981 8.875 8.875 8.875s8.875-3.981 8.875-8.875S16.894 3.125 12 3.125 3.125 7.106 3.125 12Zm-1 0c0-5.445 4.43-9.875 9.875-9.875s9.875 4.43 9.875 9.875-4.43 9.875-9.875 9.875S2.125 17.445 2.125 12Zm7.302-2.02c-.423 0-.766-.524-.766-1.17 0-.646.343-1.17.766-1.17.422 0 .765.524.765 1.17 0 .646-.343 1.17-.765 1.17Zm5.137 0c-.422 0-.765-.524-.765-1.17 0-.646.343-1.17.765-1.17s.765.524.765 1.17c0 .646-.343 1.17-.765 1.17Zm-6.741 2.768a.5.5 0 0 1 .5-.5h7.354a.5.5 0 0 1 .5.5c0 2.267-1.874 4.112-4.177 4.112-2.303 0-4.177-1.845-4.177-4.112Zm1.041.5c.245 1.479 1.558 2.612 3.136 2.612s2.89-1.133 3.136-2.612H8.864Z",
    fill: "#000"
  })));
};
export default SvgFaceMouthopenOutline;